import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { PrivateRoute } from 'src/components/Auth';
import { AppRoutes, getPathWithBaseURL } from 'src/routes';
import { BestOfRingProvider } from './context';
import { routes } from './routes';

export const BestOfRingApp = () => (
  <BestOfRingProvider>
    <Switch>
      <PrivateRoute
        component={RingHistory}
        exact
        path={getPathWithBaseURL(
          routes.RingHistory,
          AppRoutes.BestOfRing,
          true,
        )}
      />
      <Route
        exact
        component={VideoFeedPage}
        path={getPathWithBaseURL(
          routes.BestOfRingFeed,
          AppRoutes.BestOfRing,
          true,
        )}
      />
      <Route
        component={FullscreenVideoPage}
        exact
        path={getPathWithBaseURL(
          routes.BestOfRingVideoFullscreen,
          AppRoutes.BestOfRing,
          true,
        )}
      />
    </Switch>
  </BestOfRingProvider>
);

const VideoFeedPage = lazy(() =>
  import(
    /* webpackChunkName: "VideoFeedPage" */ 'src/features/BestOfRing'
  ).then(({ VideoFeedPage }) => ({
    default: VideoFeedPage,
  })),
);

const FullscreenVideoPage = lazy(() =>
  import(
    /* webpackChunkName: "FullscreenVideoPage" */ 'src/features/BestOfRing'
  ).then(({ FullscreenVideoPage }) => ({
    default: FullscreenVideoPage,
  })),
);

const RingHistory = lazy(() =>
  import(
    /* webpackChunkName: "FullscreenVideoPage" */ 'src/features/BestOfRing'
  ).then(({ RingHistory }) => ({
    default: RingHistory,
  })),
);
